<template>
  <el-container class="login_bg" type="flex" style="height:100%">
  <el-main>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item v-for="(item, index) in indexPath" :key="index">{{ item.split('-')[1] }}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin-top: 30px">
      <h3 class="title">{{ serviceInfo.companyName }}</h3>
      <div class="desc">
        <div>PC账号可用：{{ serviceInfo.usePcNum }}/{{ serviceInfo.pcActNum + serviceInfo.incPcActNum }}个，
          当前司机账号：{{ serviceInfo.useDriverNum }}/{{ serviceInfo.driverActNum + serviceInfo.incDriverActNum }}人，
          业务员账号：{{ serviceInfo.useSalesNum }}/{{ serviceInfo.salesActNum + serviceInfo.incSalesActNum }}人</div>
        <div style="line-height:50px">服务版本：{{ serviceInfo.packageName }}</div>
        <div style="line-height:50px">服务有效期至：{{ serviceInfo.expireTimeDt }}</div>
      </div>
      <el-button class="yellow_btn" style="margin-right: 20px" v-if="serviceInfo.packageSn != ''"
        @click="addService">扩容服务</el-button>
      <router-link :to="{ path: '/system/product' }" v-if="serviceInfo.packageButtonType == 2">
        <el-button class="yellow_btn" style="margin-right: 20px">转付费</el-button>
      </router-link>
      <a :href="locationHref" target="_blank">
        <el-button class="yellow_btn">进入使用</el-button>
      </a>
    </el-card>
    <el-card class="pay_goods" v-if="serviceList.length > 0">
      <h4 class="title">已购增值商品</h4>
      <div class="cards">
        <el-card shadow="hover" v-for="item in serviceList" :key="item.id">
          <div class="title">
            {{ item.packageName }}
            <div class="tags">
              <el-tag type="warning" v-if="item.serviceStatus == 1">使用中</el-tag>
              <el-tag type="danger" v-if="item.serviceStatus == 2">已过期</el-tag>
              <el-tag type="danger" v-if="item.serviceStatus == 3">已用完</el-tag>
              <el-tag type="danger" v-if="item.serviceStatus == 4">已退货</el-tag>
            </div>
          </div>
          <div class="desc">
            <div>{{ item.subject }}</div>
          </div>
        </el-card>
      </div>
    </el-card>
    <el-dialog title="增值服务" :visible.sync="dialogVisible" width="80%" center :close-on-click-modal="false"
      class="outvisibledialog" :show-close="true">
      <el-card shadow="hover" v-for="item in productList" :key="item.id">
        <i class="el-icon-upload"></i>
        <h3 class="title">{{ item.packageName }}</h3>
        <div class="desc">
          <div>{{ item.subject }}</div>
        </div>
        <el-button class="yellow_btn" @click="buyAddService(item.packageSn)">购 买</el-button>
      </el-card>
      <el-dialog width="80%" title="购 买" :visible.sync="innerVisible" :close-on-click-modal="false" append-to-body
        class="innervisibledialog" :show-close="false">
        <el-link v-if="!this.editForm" type="warning">未找到套餐编号 {{ this.$route.query.packageSn }} 的相关信息!</el-link>
        <div v-else>
          <el-card shadow="hover" v-if="editForm.appCategoryId == 3 && editForm.packageType == 1">
            <el-row>
              <el-col :span="15" style="height:100%;border-right: 1px solid #7F7F7F;height:220px">
                <h1 class="title">{{ editForm.packageName }}</h1>
                <div class="desc">
                  <div v-if="editForm.pcActNum != 0">当前套餐：{{ editForm.pcActNum }}人 / {{ editForm.unitPrice }}元 / {{
                    editForm.termUnit == 1 ? '年' : '天' }}</div>
                  <div v-if="editForm.driverActNum != 0">当前套餐：{{ editForm.driverActNum }}人 / {{ editForm.unitPrice }}元 /
                    {{
                      editForm.termUnit == 1 ? '年' : '天' }}</div>
                  <div v-if="editForm.salesActNum != 0">当前套餐：{{ editForm.salesActNum }}人 / {{ editForm.unitPrice }}元 / {{
                    editForm.termUnit == 1 ? '年' : '天' }}
                  </div>
                  <div v-if="editForm.pcActNum != 0">
                    <div>扩容套餐加购数量：
                      <el-input-number v-model="editForm.dilatationNum" controls-position="right" :min="1"
                        @change="changeDilatationNum">
                      </el-input-number>
                      <span v-if="editForm.pcActNum != 0">
                        共{{ editForm.pcActNum * editForm.dilatationNum }}人，共{{ editForm.originalAmt.toFixed(2) }}元
                      </span>
                      <span v-if="editForm.driverActNum != 0">
                        共{{ editForm.driverActNum * editForm.dilatationNum }}人，共{{ editForm.originalAmt.toFixed(2) }}元
                      </span>
                      <span v-if="editForm.salesActNum != 0">
                        共{{ editForm.salesActNum * editForm.dilatationNum }}人，共{{ editForm.originalAmt.toFixed(2) }}元
                      </span>
                    </div>
                  </div>
                  <div v-if="editForm.driverActNum != 0">
                    <div>司机账号加购数量：
                      <el-input-number v-model="editForm.dilatationNum" controls-position="right" :min="0"
                        @change="changeDilatationNum">
                      </el-input-number>
                      人，共{{ editForm.originalAmt.toFixed(2) }}元
                    </div>
                  </div>
                  <div v-if="editForm.salesActNum != 0">
                    <div>业务员账号加购数量：
                      <el-input-number v-model="editForm.dilatationNum" controls-position="right" :min="0"
                        @change="changeDilatationNum">
                      </el-input-number>
                      人，共{{ editForm.originalAmt.toFixed(2) }}元
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="8" :offset="1" style="line-height: 110px;">
                <div>总价 <span>¥ {{ editForm.originalAmt.toFixed(2) }}</span></div>
                <el-button class="yellow_btn" @click="affirmOrder">提交订单</el-button>
                <el-button @click="beforeClose">取 消</el-button>
              </el-col>
            </el-row>
          </el-card>
          <el-card shadow="hover" v-if="editForm.appCategoryId == 2 && editForm.packageType == 2">
            <el-row>
              <el-col :span="15" style="height:100%;border-right: 1px solid #7F7F7F;height:220px">
                <h1 class="title">{{ editForm.packageName }}</h1>
                <div class="desc">
                  <div>当前套餐：{{ editForm.unitPrice }} / 千条</div>
                  <div>短信套餐加购数量：
                    <el-input-number v-model="editForm.purchaseNum" controls-position="right" :min="0" :max="999999">
                    </el-input-number>
                    千条，共{{ (editForm.purchaseNum * editForm.unitPrice).toFixed(2) }}元
                  </div>
                </div>
              </el-col>
              <el-col :span="8" :offset="1" style="line-height: 110px;">
                <div>总价 <span>¥ {{ (editForm.purchaseNum * editForm.unitPrice).toFixed(2) }}</span></div>
                <el-button class="yellow_btn" @click="affirmOrder">提交订单</el-button>
                <el-button @click="beforeClose">取 消</el-button>
              </el-col>
            </el-row>
          </el-card>
        </div>
      </el-dialog>
    </el-dialog>
  </el-main>

  <div class="footer-copyright">Copyright@2016-2023杭州闪派网络科技有限公司版权所有 网站备案/许可证号：
      <a href="https://beian.miit.gov.cn/" target="“_blank&quot;">浙ICP备16031137号</a>
      <img :src="require('@/assets/images/gongan.png')" alt="" style="vertical-align: middle;margin-left: 10px;"> 浙公网安备案
      <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502007569"
        target="“_blank&quot;">33010502007569</a>
    </div>
  </el-container>
</template>
<script>
import {
  getCompanyServiceInfo,
  getCompanyServiceList,
  getUserNumber,
  getProductList,
  getProductInfo,
  affirmOrder
} from '@/api.js'
import {
  mapState
} from 'vuex'
export default {
  name: "CompanyCurrentService",
  data() {
    return {
      serviceList: [],
      serviceInfo: {
        companyName: '',
        packageName: '',
        usePcNum: 0,
        pcActNum: 0,
        incPcActNum: 0,
        useDriverNum: 0,
        driverActNum: 0,
        incDriverActNum: 0,
        useSalesNum: 0,
        salesActNum: 0,
        incSalesActNum: 0
      },
      locationHref: 0,
      dialogVisible: false,
      innerVisible: false,
      productList: [],
      editForm: {
        superPackageSn: '',
        packageSn: '',
        originalAmt: 0,
        paymentAmount: 0,
        discountAmt: '',
        termUnit: '',
        addPcActNum: 0,
        addSalesActNum: 0,
        addDriverActNum: 0,
        dilatationNum: 1,
        cid: this.AdminId,
        isRenew: 0,
        pcActNum: 0,
        driverActNum: 0,
        salesActNum: 0,
        pcActUnitPrice: 0,
        driverActUnitPrice: 0,
        salesActUnitPrice: 0,
        purchaseNum: 1
      }
    }
  },
  created() {
    this.getCompanyServiceList()
    this.getCompanyServiceInfo()
    const location = window.location.href.indexOf('192.168.0.')
    const location200 = window.location.href.indexOf('gogit.52shanpai.com')
    const locationP = window.location.href.indexOf('dealer.52shanpai.com')
    if (location != -1) {
      this.locationHref = 'http://192.168.0.102:5173/'
    } else if (location200 != -1) {
      this.locationHref = 'http://gogit.52shanpai.com:1240/'
    } else if (locationP != -1) {
      this.locationHref = 'https://dealer.52shanpai.com:9191/'
    }
  },
  mounted() { },
  methods: {
    getCompanyServiceList() {
      getCompanyServiceList({
        Cid: this.AdminId,
        AppCategoryId: 2,
        Size: -1
      }).then(res => {
        if (res.code == 0) {
          this.serviceList = res.data.list ? res.data.list : []
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getCompanyServiceInfo() {
      getCompanyServiceInfo({
        Cid: this.AdminId,
      }).then(res => {
        if (res.code == 0) {
          if (res.data.companyServiceInfo) {
            this.serviceInfo = res.data.companyServiceInfo
            this.getUserNumber()
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getUserNumber() {
      getUserNumber({
        Cid: this.AdminId,
      }).then(res => {
        if (res.code == 0) {
          if (res.data.info) {
            this.$set(this.serviceInfo, "useDriverNum", res.data.info.useDriverNum)
            console.log(this.serviceInfo)
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    addService() {
      this.productList = []
      this.getProductList(3, 1)
      this.getProductList(2, 2)
      this.dialogVisible = true
    },
    getProductList(appCategoryId, packageType) {
      getProductList({
        appCategoryId: appCategoryId,
        packageType: packageType
      }).then(res => {
        if (res.code == 0) {
          if (res.data.list) {
            this.productList = this.productList.concat(res.data.list)
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    buyAddService(packageSn) {
      this.getProductInfo(packageSn)
    },
    getProductInfo(packageSn) {
      getProductInfo({
        packageSn: packageSn
      }).then(res => {
        if (res.code == 0) {
          this.editForm = res.data.Info
          // this.editForm['dilatationNum'] = null
          this.$set(this.editForm, "dilatationNum", 1)
          this.$set(this.editForm, "purchaseNum", 1)
          this.editForm['originalAmt'] = this.editForm.unitPrice * 1
          this.innerVisible = true
        } else {
          this.$message.error(res.message)
        }
      })
    },
    changeDilatationNum(val) {
      console.log(val)
      this.editForm.originalAmt = this.editForm.unitPrice * this.editForm.dilatationNum
    },
    affirmOrder() {
      this.editForm['paymentAmount'] = this.editForm.originalAmt
      if (this.editForm.pcActNum != 0) {
        this.editForm.addPcActNum = this.editForm.dilatationNum
      }
      if (this.editForm.driverActNum != 0) {
        this.editForm.addDriverActNum = this.editForm.dilatationNum
      }
      if (this.editForm.salesActNum != 0) {
        this.editForm.addSalesActNum = this.editForm.dilatationNum
      }
      this.editForm.superPackageSn = this.serviceInfo.packageSn
      affirmOrder(this.editForm).then(res => {
        this.dialogVisible = false
        this.innerVisible = false
        if (res.code == 0) {
          this.$router.push({
            path: '/system/software_purchase_details',
            query: {
              orderId: res.data.affirmOrder.orderId
            }
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },
    beforeClose() {
      this.innerVisible = false
      this.editForm = {
        packageSn: '',
        originalAmt: 0,
        paymentAmount: 0,
        discountAmt: '',
        termUnit: '',
        addPcActNum: 0,
        addSalesActNum: 0,
        addDriverActNum: 0,
        dilatationNum: 1,
        cid: this.AdminId,
        isRenew: 0,
        pcActNum: 0,
        driverActNum: 0,
        salesActNum: 0,
        pcActUnitPrice: 0,
        driverActUnitPrice: 0,
        salesActUnitPrice: 0,
        purchaseNum: 1
      }
    }
  },
  computed: {
    ...mapState({
      indexPath: state => state.indexPath,
      AdminId: state => state.AdminId,
    }),
  },
}
</script>

<style scoped lang="scss">
.el-container {
  flex-direction: column;

  .footer-copyright {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
  }
}
.pay_goods {
  margin-top: 20px;

  h4 {
    margin-top: 0;
  }

  .cards {
    display: flex;
  }

  .el-card {
    position: relative;
    width: 400px;
    height: 150px;
    margin-right: 20px;

    .title {
      font-size: 20px;

      .tags {
        float: right;

        .el-tag {
          margin-right: 10px
        }
      }
    }

    .desc {
      margin-top: 20px;
      font-size: 14px;
      color: rgb(170, 170, 170);
    }

  }

  .el-card:last-child {
    margin-right: 0;
  }


}

:deep(.outvisibledialog) {
  .el-dialog__body {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;

    .el-card {
      position: relative;
      text-align: center;
      width: 200px;
      height: 300px;
      margin-top: 20px;

      i {
        color: #333333;
        font-size: 90px;
      }

      .desc {
        text-align: left;
        color: rgb(170, 170, 170);
        text-align: center;
      }

      .el-button {
        width: 140px;
        position: absolute;
        left: calc(50% - 70px);
        bottom: 20px;

      }
    }
  }
}

:deep(.innervisibledialog) {
  .el-dialog__body {
    .el-card {
      max-width: 1000px;
      position: relative;
      margin: 0 auto;

      .el-col:last-child {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
      }

      .desc {
        width: 400px;
        font-size: 14px;
        line-height: 50px;
      }
    }
  }
}
</style>